import { render, staticRenderFns } from "./InvitationRecord.vue?vue&type=template&id=5c78119a&scoped=true&"
import script from "./InvitationRecord.vue?vue&type=script&lang=js&"
export * from "./InvitationRecord.vue?vue&type=script&lang=js&"
import style0 from "./InvitationRecord.vue?vue&type=style&index=0&id=5c78119a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78119a",
  null
  
)

export default component.exports